import axios from "axios";
import envManager from "../managers/env";

// Create a app-specific instance of axios with a custom config
const instance = axios.create({
  timeout: envManager.getApiTimeoutMilliSeconds()
});

export default instance;



// WEBPACK FOOTER //
// ./src/services/api/axios-default.js